
























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {WardStore} from "../../store";
import {Ward} from "@/interfaces/entity";
import {CommonStatus} from "@/enums/status";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: "WardAction"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true }) id!: number;
    CommonStatus = CommonStatus;

    get record() {
        return WardStore.data[this.id];
    }

    async save(id: number) {
        const ward: Ward = WardStore.data[id];
        if (!ward) return;
        try {
            WardStore.updateDataWardV21({ key: id, value: { ...ward, isSaving: true } });
            await WardStore.editWardV21(ward);
            WardStore.updateCachedDataWardV21({ key: id, value: ward })
            this.$message.success("Sửa phường/xã thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa phường/xã thất bại");
        } finally {
            WardStore.updateDataWardV21({ key: id, value: { ...ward, isSaving: false } });
            WardStore.updateDataWardV21({ key: id, value: { ...ward, editable: false } });
        }
    }

    edit(id: number) {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_EDIT_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        const ward: any = { ...WardStore.data[id] };
        if (!ward) return;
        WardStore.updateDataWardV21({ key: id, value: { ...ward, isSaving: false } });
        WardStore.updateDataWardV21({ key: id, value: { ...ward, editable: true } });
    }

    async deleteWard(id: number) {
        try {
            WardStore.updateDataWardV21({ key: id, value: { ...WardStore.data[id], isDeleting: true } });
            await WardStore.deleteWardV21(id);
            this.$message.success("Xóa phường/xã thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa phường/xã thất bại");
        } finally {
            WardStore.updateDataWardV21({ key: id, value: { ...WardStore.data[id], isDeleting: false } });
        }
    }

    close(id: number) {
        let ward = { ...WardStore.data[id] };
        if (!ward) return;
        ward = { ...ward, ...WardStore.cachedData[id], ['editable']: false } as any;
        WardStore.updateDataWardV21({ key: id, value: ward })
    }
}
